import React from 'react'
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { setLanguage } from "redux-i18n";
import * as commonActions from "../../../redux/actions/commonAction";
import * as modalActions from "../../../redux/actions/modalActions";
import * as authActions from "../../../redux/actions/userAuthAction";
import MyReportPage from '../../../components/Report/MyReport'
import Sidebar from '../../../components/Sidebar';
import { ShowForPermission } from "../../../components/UserAuth/ShowForPermissionComponent";
import { PERMISSION_TYPE, PERMISSON_MODULES } from "../../../Permission.config";
import { useEffect } from 'react';
import { useState } from 'react';
import { PREFERED_LANGUAGE_KEYS } from '../../../App.config';

const MyReport = (props, context) => {

    const [reports, setReports] = useState([]);

    const profileReducer = useSelector((state) => state.profileReducer);
    const authReducer = useSelector((state) => state.userAuthReducer);

    const commonReducer = useSelector((state) => state.commonReducer);
    const companyReducer = useSelector((state) => state.companyReducer);
    const i18nReducer = useSelector((state) => state.i18nState);
    const dispatch = useDispatch();

    const commonAction = bindActionCreators(commonActions, dispatch);
    const modalAction = bindActionCreators(modalActions, dispatch);
    const authAction = bindActionCreators(authActions, dispatch);

    const openSetModal = (children) => {
        modalAction.openSetModal(children);
    };

    const closeRemoveModal = () => {
        modalAction.closeRemoveModal();
    };

    const languageChange = (language) => {
        dispatch(setLanguage(language));
    };

    const onMenuToggle = (isOpen) => {
        commonAction.setIsSideMenuOpen(isOpen);
    };

    const getLelvelItemsForLevel = (level) => {
        authAction.getCompanyLevelItems(level);
    }

    const getCompanyLevels = () => {
        authAction.getCompanyAssignedLevel();
    }

    const getCompanyLocationsByRegion = (regionId) => {
        authAction.getDepartmentByRegionId(regionId);
    }

    useEffect(() => {
        let data = {
            companyId: profileReducer?.managersDetails?.lstAssignedCompany,
            roleId: profileReducer?.managersDetails?.roleId,
            isLangEng: i18nReducer.lang == PREFERED_LANGUAGE_KEYS.EnglishUS
        }
        authAction.GetMyAccessReport(data);
        authAction.getRegionByCompanyId(profileReducer?.managersDetails?.companyId)
    }, [i18nReducer.lang])

    useEffect(() => {
        setReports([]);
        let r = [];
        authReducer.userAccessReport && authReducer.userAccessReport.map((report) => {

            if (report.companyId == profileReducer?.managersDetails?.companyId) {
                r.push(report);
            }

            setReports(r);
        })
    }, [authReducer.userAccessReport])

    useEffect(() => {

        setReports([]);
        let r = [];
        authReducer.userAccessReport && authReducer.userAccessReport.map((report) => {

            if (report.companyId == profileReducer?.managersDetails?.companyId) {
                r.push(report);
            }

            setReports(r);
        })
    }, [profileReducer?.managersDetails?.companyId])

    return (
        <>
            {window.location.hash !== "#/" && (
                <Sidebar
                    languageChange={languageChange}
                    openSetModalAction={openSetModal}
                    closeRemoveModal={closeRemoveModal}
                    managersDetails={profileReducer.managersDetails}
                    onMenuToggle={onMenuToggle}
                    isSideMenuOpen={commonReducer.isSideMenuOpen}
                    context={context}
                />
            )}
            <div className="Content-Panel">
                <ShowForPermission module={PERMISSON_MODULES.MY_REPORT} permission={PERMISSION_TYPE.VIEW}>
                    <MyReportPage
                        reports={reports}
                        context={context}
                        levelItems={companyReducer.companyLevelItems}
                        lstCompanyLevelData={companyReducer.companyAssignedLevels}
                        regionList={authReducer.regionList}
                        departmentList={authReducer.departmentList}
                        getLelvelItemsForLevel={getLelvelItemsForLevel}
                        getCompanyLevels={getCompanyLevels}
                        getCompanyLocationsByRegion={getCompanyLocationsByRegion}
                    />
                </ShowForPermission>

            </div>
        </>
    )
}

MyReport.contextTypes = {
    t: PropTypes.func.isRequired,
};

export default MyReport;